import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DxAutocompleteModule, DxButtonModule, DxChartModule, DxCheckBoxModule, DxDataGridModule, DxDropDownButtonModule, DxLoadPanelModule, DxPivotGridFieldChooserModule, DxPivotGridModule, DxPopupModule, DxScrollViewModule, DxSelectBoxModule, DxTextBoxModule, DxTooltipModule } from 'devextreme-angular';
import { BookmarkModule } from 'src/app/widgets/bookmark/bookmark.module';
import { FiltersGroupModule } from 'src/app/widgets/filters/filters-group/filters-group.module';
import { AdjustmentComponent } from './adjustment.component';
import { ScenarioAdjustmentRoutingModule } from './adjustment-rounting.module';
import { BookmarkNewComponent } from 'src/app/widgets/bookmark-new/bookmark-new.component';


@NgModule({
	declarations: [AdjustmentComponent],
	imports: [
		CommonModule,
		DxChartModule,
		ScenarioAdjustmentRoutingModule,
		DxScrollViewModule,
		DxAutocompleteModule,
		DxDataGridModule,
		DxPopupModule,
		DxButtonModule,
		DxDropDownButtonModule,
		DxPivotGridModule,
		DxPivotGridFieldChooserModule,
		DxCheckBoxModule,
		DxLoadPanelModule,
		DxTooltipModule, DxScrollViewModule,
		DxSelectBoxModule,
		BookmarkModule,
		BookmarkNewComponent,
		FiltersGroupModule,
		DxTextBoxModule
	]
})
export class ScenarioAdjustmentModule { }
